import { Theme } from "@mui/material";

const userStyles = (theme: Theme) => {
  return {
    textField: {
      fontSize: "16px",
      "& .MuiInputBase-input": {
        padding: "10px 8px",
      },
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:hover:before": {
        borderBottom: "1px solid #47556940 !important",
      },
      "& .MuiInput-underline:after": {
        borderBottom: "1px solid #7551D0 !important",
      },
    },
    dropDown: {
      height: "47px",
      backgroundColor: "#FFFFFF",
      "& .MuiSelect-outlined": {
        color: "#475569",
        fontWeight: 600,
      },
      "&:hover": {
        background: "transparent",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
    },
    dropDownMenuItem: {
      fontSize: "14px",
      "&:not(:last-child)": {
        borderBottom: "1px solid #e0e0e0",
      },
      "&.Mui-selected": {
        backgroundColor: "#FFFFFF",
        color: theme.palette.primary.main,
        fontWeight: 500,
      },
      "&:focus": { backgroundColor: "#FFFFFF" },
    },
  };
};

export default userStyles;
